import utils from "Sources/utils/utils";
//import NavUtils from "Sources/utils/navigation-utils";
const log = require("Sources/utils/logger")();
import LanguageManager from "Sources/services/language-manager";
import HtmlTemplate from "Views/partials/objectives/mission-objective.html";

import "Styles/components/mission-objective.scss";

class MissionObjective
{
  constructor(options)
  {
    this.$container = $(options.container);
    this.hasRendered = false;
    this.objective = options.objective;
    this.onObjectiveSelected = options.onObjectiveSelected;
    this.showCheckmark = options.showCheckmark;
    this.selected = false;
  }

  get objective()
  {
    return this._objective;
  }

  set objective(objective)
  {
    this._objective = objective;
    this.updateMissionObjective();
  }

  static setUpMissionObjective(options)
  {
    let instance = new MissionObjective(options);
    instance.render();
    if(options.selected)
    {
      instance.setSelected();
      //instance.onObjectiveSelected();
    }

    if(!options.showCheckmark)
    {
      instance.$element.find("[data-bind-target='objective-checkbox']").hide();
    }

    instance.updateMissionObjective();

    instance.setUpEventListeners();
    return instance;
  }

  setUpEventListeners()
  {
    const CHECKBOX_ID = ".objective-checkbox";
    const INFINITE_BTN_ID = ".objective-infinite-btn";

    let that = this;

    this.$element.find(CHECKBOX_ID).on("change", function(e)
    {
      if(e.target.checked)
      {
        that.selected = true;
      }
      else
      {
        that.selected = false;
      }
      that.onObjectiveSelected();
    });

  }

  setUnselected()
  {
    this.$element.find(".objective-checkbox").prop("checked", false);
    this.selected = false;
  }

  setSelected()
  {
    this.$element.find(".objective-checkbox").prop("checked", true);
    this.selected = true;
  }


  render()
  {
    this.hasRendered = false;
    this.$element = $(HtmlTemplate);
    this.$container.prepend(this.$element);
    LanguageManager.applyLocale(this.$element);

    this.updateMissionObjective();
    this.hasRendered = true;
  }

  show()
  {
    if(utils.isNotNull(this.$element) && this.$element.length)
    {
      this.$element.show();
    }
  }

  hide()
  {
    if(utils.isNotNull(this.$element) && this.$element.length)
    {
      this.$element.hide();
    }
  }

  destroy()
  {
    if(utils.isNotNull(this.$element) && this.$element.length)
    {
      this.$element.remove();
    }
  }

  closeAndUpdate()
  {
    this.updateMissionObjective();
  }

  updateMissionObjective() {
    if (utils.isNotNull(this.$element) && this.$element.length) {
      let $objectiveName = this.$element.find("[data-bind-target='objective-name']");
      $objectiveName.empty();

      if (utils.isNotNull(this.objective) && utils.isNotNull(this.objective.code) && utils.isNotNull(this.objective.key)) {
        $objectiveName.text(this.objective.code);
        $objectiveName.attr("for", "objective-checkbox-" + this.objective.key);
      }

      let $objectiveCheckbox = this.$element.find("[data-bind-target='objective-checkbox']");
      $objectiveCheckbox.empty();

      if (utils.isNotNull(this.objective) && utils.isNotNull(this.objective.key)) {
        $objectiveCheckbox.attr("id", "objective-checkbox-" + this.objective.key);
      }


    }
  }

}

export default MissionObjective;



// WEBPACK FOOTER //
// ./app/js/components/mission-objective.js